// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"347":"a11cd12a","595":"9c1e2414"}[chunkId] + ".chunk.css";
};